
import React from 'react';

interface BadgeProps {
  children: React.ReactNode;
  variant?: 'default' | 'value-i' | 'value-ii' | 'value-iii' | 'value-iv' | 'status';
  className?: string;
}

export default function Badge({ children, variant = 'default', className = '' }: BadgeProps) {
  const baseClasses = 'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium';
  
  const variantClasses = {
    default: 'bg-gray-100 text-gray-800',
    'value-i': 'bg-green-100 text-green-800',
    'value-ii': 'bg-yellow-100 text-yellow-800',
    'value-iii': 'bg-orange-100 text-orange-800',
    'value-iv': 'bg-red-100 text-red-800',
    status: 'bg-blue-100 text-blue-800',
  };

  return (
    <span className={`${baseClasses} ${variantClasses[variant]} ${className}`}>
      {children}
    </span>
  );
}
